module.exports = __webpack_public_path__ + "static/media/back.8eae50a5.svg";